import { CREATE_AFTERMARKET_PRODUCTS } from './createAftermarketProduct';
import { UPDATE_AFTERMARKET_PRODUCTS } from './updateAftermarketProduct';

import { GET_PARTNER_LINKS } from './getPartnerLincks';
import { GET_AFTERMARKET_PRODUCT_BY_ID } from './getAftermarketProductsById';
import { GET_AFTERMARKET_PRODUCTS } from './getListAftermarketProductsByAccount';
import { GET_AFTERMARKET_ADDONS_PRODUCTS_OPTIONS } from './getListAddonsOptionsByAccount';

export const aftermarketProductsApi = {
  createProduct: CREATE_AFTERMARKET_PRODUCTS,
  updateProduct: UPDATE_AFTERMARKET_PRODUCTS,

  getPartnerLinks: GET_PARTNER_LINKS,
  getProductsById: GET_AFTERMARKET_PRODUCT_BY_ID,
  getListProductsByAccountId: GET_AFTERMARKET_PRODUCTS,
  getAddonsOptionsByAccountId: GET_AFTERMARKET_ADDONS_PRODUCTS_OPTIONS,
};
